<template>
    <div>
        <c-card>
            <c-card-header>
                <strong>Add Supplier</strong>
            </c-card-header>
            <c-card-body>
                <c-form>
                    <div class="form-group form-row">
                        <label class="col-form-label col-sm-3">Perusahaan</label>
                        <div class="col-md-9">
                            <input type="text" class="form-control" v-model="sup.perusahaan"
                                   placeholder="perusahaan.." v-bind:class="{'has-error': hasError.perusahaan}">
                        </div>
                    </div>
                    <div class="form-group form-row">
                        <label class="col-form-label col-sm-3">Supplier Name</label>
                        <div class="col-md-9">
                            <input type="text" class="form-control" v-model="sup.name"
                                   placeholder="supplier name.." v-bind:class="{'has-error': hasError.name}">
                        </div>
                    </div>
                    <div class="form-group form-row">
                        <label class="col-form-label col-sm-3">Address</label>
                        <div class="col-md-9">
                            <textarea cols="30" rows="3" class="form-control" v-model="sup.address"
                                      placeholder="address.." v-bind:class="{'has-error': hasError.address}"/>
                        </div>
                    </div>
                    <div class="form-group form-row">
                        <label class="col-form-label col-sm-3">Phone</label>
                        <div class="col-md-9">
                            <input type="text" class="form-control" v-model="sup.phone"
                                   placeholder="phone.." v-bind:class="{'has-error': hasError.perusahaan}">
                        </div>
                    </div>
                    <div class="form-group form-row">
                        <label class="col-form-label col-sm-3">Email</label>
                        <div class="col-md-9">
                            <input type="email" class="form-control" v-model="sup.email"
                                   placeholder="email.." v-bind:class="{'has-error': hasError.email}">
                        </div>
                    </div>
                </c-form>
            </c-card-body>
            <c-card-footer>
                <sur-button @onSave="save" @onUpdate="update" @onReset="reset" :object="sup"/>
            </c-card-footer>
        </c-card>
    </div>
</template>

<script>
    import SURButton from "../../components/SURButton";
    import {HTTPAUTH} from "../../lib/httplib";
    export default {
        name: "SupplierAdd",
        components: {
            'sur-button': SURButton,
        },
        data() {
            return {
                hasError: {},
                sup: {}
            }
        },
        created() {
            const query = this.$route.query;
            if (query.id) {
                this.get(query.id);
            }
        },
        methods: {
            get(id) {
                HTTPAUTH.get("/api/v1/supplier/" + id).then(res => {
                    this.sup = res.data.data;
                })
            },
            save() {
                HTTPAUTH.post("/api/v1/supplier", this.sup).then(() => {
                    this.$toasted.success("Berhasil disimpan").goAway(2000);
                    this.reset();
                }).catch(eres => {
                    this.$toasted.error(eres.response.data.message).goAway(3000);
                    this.hasError = eres.response.data.errors;
                })
            },
            update() {
                HTTPAUTH.put("/api/v1/supplier/" + this.sup.id, this.sup).then(() => {
                    this.$toasted.success("Berhasil disimpan").goAway(2000);
                    this.reset();
                }).catch(eres => {
                    this.$toasted.error(eres.response.data.message).goAway(3000);
                    this.hasError = eres.response.data.errors;
                })
            },
            reset() {
                this.sup = {};
                this.$router.push({query: {}})
            },
        }
    }
</script>

<style scoped>

</style>
